var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitzerlandFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_4194_384)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4194_384",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4194_384",
    transform: "scale(0.0185185)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4194_384",
    width: 54,
    height: 54,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAAPtJREFUaEPtmDsOwjAMhh3YkZBYWbpyB7g7Z4BbMDGxlKJKjJXsP4pRib6utZ34f+RVbmU/WYdfmRs7TqW71mjs3yiFMRhbCQJIcSVEhKcBY2GovoG79yOU8twcQnFqUBpjNAZjmhiRooaXGR7DY5pm8JiGFx4zTh6iZEIeiy7d4tjV4R7Lr8tgNFYNb0IijHkPpngsQXZLJZEiUvyR1LxhkKInRQ/Bpf/RldRDv2bsOSd08qgpTmPcoDXdIEUNL27Q3KBVxeAxFTH2MfYxTTN4TMPLbHs+hVLG6z0UpwalMaZOpHU8jbVGNLsejGUj3Lo+jLVGNLtet4x9ACFIGw9syOQfAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitzerlandFlag);
export default __webpack_public_path__ + "static/media/switzerland_flag.4f5d397cdc6080f4f1c739f8540fe31a.svg";
export { ForwardRef as ReactComponent };